<template>
  <div class="payment-bank-modal-container">
    <table-content
      v-if="visibleModal && loaded"
      :responses="responses"
      :payments="payments.items"
    />
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import TableContent from './Table'

const ResponsesAPI = RepositoryFactory.get('responses')
const PaymentsAPI = RepositoryFactory.get('payments')

export default {
  name: 'Form',
  components: { TableContent },
  props: {
    content: {
      type: Object,
      default: () => {},
    },
    visibleModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      payments: {
        items: {},
      },
      responses: [],
      loaded: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async getResponses() {
      const ar = this.content.load_days_ids.map(el =>
        ResponsesAPI.getResponsesLoadDay(el),
      )
      const response = await Promise.all(ar)

      let responses = response
        .map(e => e.data.items)
        .reduce((acc, el) => acc.concat(el), [])

      this.payments.items.forEach(payment => {
        responses = responses.map(response => {
          if (payment.response_id === response.id) {
            response.payments = [...(response.payments || []), payment]
          }

          return response
        })
      })
      this.responses = response[0].data.items
      this.loaded = true
    },
    async getPayments() {
      await PaymentsAPI.listByLoadDaysId(this.content.load_days_ids).then(
        response => {
          this.payments.items = response.data
          this.payments.loaded = true
        },
      )
    },
    init() {
      this.getPayments()
      this.getResponses()
    },
  },
}
</script>
